import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { FillDataForSimulationClientResponse } from '../@types/fillDataForSimulation'
import { QuestionsBlock } from '../Types/AnimalStore'

type Store = {
  questionary: QuestionsBlock[]
  fillDataForSimulationRequest: FillDataForSimulationClientResponse | null
  setFillDataForSimulationRequest: (
    fillDataForSimulationRequest: FillDataForSimulationClientResponse,
  ) => void
}

export const useFillDataForSimulationStore = create<Store>()(
  devtools(
    (set) => ({
      questionary: [],
      fillDataForSimulationRequest: null,
      setFillDataForSimulationRequest: (fillDataForSimulationRequest) => {
        return set(() => {
          const newData = (
            fillDataForSimulationRequest?.questionsResponse?.sections || []
          )?.map((section) => ({
            id: section?.code || '',
            title: section?.name || '',
            questions: (section?.questions || [])?.map((question) => {
              return {
                id: question?.code || '',
                question: question?.description || '',
                responseTypeCode: question?.responseTypeCode || '',
                order: question?.order || '',
                answer: null,
                conditions: question?.conditions || [],
              }
            }),
          })) as QuestionsBlock[]

          return { fillDataForSimulationRequest, questionary: newData }
        })
      },
    }),
    { name: 'FillDataForSimulationStore' },
  ),
)
